import MyHeader from '../../components/header';
import MyFooter from '../../components/footer';
import { auth, db } from '../../firebase';

import Spacer from '../../components/spacer';
import { Form, Link, useLoaderData, useNavigate } from 'react-router-dom';
import l from './a.module.scss';
import { useEffect } from 'react';
import { getValFrmDict, sdgs, slug } from '../../../k4dAdmin/data';

import { truncateForLink } from '../../data';

export const faqloader =
  (useApiProviderCtx) =>
  async ({ params, request }) => {
    const { fetchFaqs } = useApiProviderCtx;
    let w2 = {};
    //const vex =
    try {
      w2 = await fetchFaqs({});
    } catch (e) {}

    return { ...params, recent: { ...w2 } };
    //return w2;
  };

export default function Faq() {
  const { recent } = useLoaderData();

  return (
    <>
      <MyHeader />
      <div className={l.whole0}>
        <div className={l.whole}>
          <div className={l.co}>
            <Spacer />
            <h1>Frequently Asked Questions</h1>

            <p>
              knowledge for development provides researchers the opportunity to share their findings for sustainable
              development and growth. This medium recognizes and respects the right of participation of rural
              communities in of moral and social justice cannot be over-emphasized in all rural and developing
              communities.
            </p>

            {recent?.data?.map((v, i) => {
              return (
                <div key={i}>
                  {v?.question}
                  <hr />
                </div>
              );
            })}
          </div>
          <MyFooter />
        </div>
      </div>
    </>
  );
}
